import { ReactElement } from 'react'

import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import {
  Footer as DSFooter,
  FooterProps as DSFooterProps,
} from '@awaze/design-system.compositions.footer'
import { renderContentfulRichText } from '@awaze/mfe-common.lib.contentful/dist/api/utils/render-richtext'

import { useLocations } from '@/components/LocationSelector/useLocations'
import { richTextOptions } from '@/utils/contentful'

export interface FooterProps extends Omit<DSFooterProps, 'locationSelect'> {
  currency: string
  country: string
  brand: Brand
}

export const Footer: React.FC<FooterProps> = ({
  currency,
  country,
  brand,
  labels,
  ...domAttributes
}) => {
  return (
    <DSFooter
      {...domAttributes}
      locationSelect={useLocations(brand, currency, country)}
      labels={{
        ...labels,
        // TODO - This should be ReactNode (anything that can be rendered by react - string, null, component, whatever)
        // in the design system, not ReactElement (must be a component)
        companyInformation: renderContentfulRichText(
          labels.companyInformation,
          richTextOptions,
        ) as ReactElement,
      }}
    />
  )
}
